
// Dynamisk bilde i mega menu links hover
document.addEventListener("DOMContentLoaded", function () {
  // Select all mega menu lists
  const megaMenuLists = document.querySelectorAll(".mega-menu__linklist");

  megaMenuLists.forEach((menuList) => {
    // Select the image corresponding to this mega menu
    const dynamicImage = menuList.nextElementSibling.querySelector("img");
    const defaultImageSrc = dynamicImage.getAttribute("src");

    const menuItems = menuList.querySelectorAll("li[data-image-url]");

    // Function to fade image in
    function fadeInImage(newSrc) {
      dynamicImage.style.opacity = 0;
      setTimeout(function () {
        dynamicImage.src = newSrc;
        dynamicImage.style.opacity = 1;
      }, 500); // Match this duration with the CSS transition time
    }

    // Handle mouseenter for each menu item
    menuItems.forEach((item) => {
      item.addEventListener("mouseenter", function () {
        const imageUrl = this.dataset.imageUrl;
        if (dynamicImage && imageUrl) {
          fadeInImage(`//j-kshop.no/cdn/shop/${imageUrl}`);
        }
      });
    });

    // Revert to the default image when the mouse leaves the mega menu list
    menuList.addEventListener("mouseleave", function () {
      fadeInImage(defaultImageSrc);
    });
  });
});

// Dynamisk bilde i sidebar menu sub links clicks
const placeholderImageHenne =
  "//j-kshop.no/cdn/shop/t/56/assets/henne.webp?v=95653502462916773571726315394";
const placeholderImageHan =
  "//j-kshop.no/cdn/shop/t/56/assets/han.webp?v=87962863515435619361726315383";

function updateImageHenne(imageUrl) {
  const imageElement = document.getElementById(
    "dynamic-category-image-mobile-henne"
  );

  // Check if the clicked image is the same as the current image
  if (
    imageElement &&
    imageElement.getAttribute("data-last-clicked") === imageUrl
  ) {
    // If it is, reset to placeholder and clear data-last-clicked attribute
    imageElement.src = placeholderImageHenne;
    imageElement.removeAttribute("data-last-clicked");
    console.log("Reset image to Henne default.");
  } else if (imageElement) {
    // If it's a new image, update src and set data-last-clicked attribute
    imageElement.src = imageUrl || placeholderImageHenne;
    imageElement.setAttribute("data-last-clicked", imageUrl);
    console.log("Updated image to: ", imageElement.src);
  } else {
    console.log("Image element not found.");
  }
}
window.updateImageHenne = updateImageHenne;

function updateImageHan(imageUrl) {
  const imageElement = document.getElementById(
    "dynamic-category-image-mobile-han"
  );

  // Toggle the image back to the placeholder if it's already displaying the clicked image
  if (
    imageElement &&
    imageElement.getAttribute("data-last-clicked") === imageUrl
  ) {
    imageElement.src = placeholderImageHan;
    imageElement.removeAttribute("data-last-clicked");
    console.log("Reset image to Han default.");
  } else if (imageElement) {
    // If it's a new image, update the src and remember it as the last-clicked
    imageElement.src = imageUrl || placeholderImageHan;
    imageElement.setAttribute("data-last-clicked", imageUrl);
    console.log("Updated image to: ", imageUrl);
  } else {
    console.log("Image element not found.");
  }
}
window.updateImageHan = updateImageHan;

// leveringsmelding variant endring
(() => {
  function initPreorderMessage(scope) {
    const msg = scope.querySelector('[data-preorder-message]');
    const json = scope.querySelector('script[data-variant-inventory]');

    console.log("msg: ", msg);
    console.log("json :", json);
    
    if (!msg || !json) return;

    let variants;
    try {   
      variants = JSON.parse(json.textContent).variants || {};
    } catch (e) {
      return;
    }

    const min = parseInt(msg.dataset.min || '0', 10);
    const max = parseInt(msg.dataset.max || '0', 10);

    function setVisibilityByVariantId(variantId) {
      if (!variantId) return;

      const qty = parseInt(variants[String(variantId)] ?? 0, 10);
      const show = qty >= min && qty <= max;

      console.log("quantity: ", qty);
      console.log("show: ", show);

      msg.style.display = show ? '' : 'none';
    }

    // initial (på page load)
    const idInput = scope.querySelector('input[name="id"], select[name="id"]');
    if (idInput?.value) setVisibilityByVariantId(idInput.value);

    // instant on variant change (temaet ditt bruker denne)
    const form = scope.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener('variant:change', (e) => {
        const id = e?.detail?.variant?.id || form?.id?.value || idInput?.value;
        setVisibilityByVariantId(id);
      });
    }

    // fallback hvis temaet kun oppdaterer hidden input uten custom event i noen views
    scope.addEventListener('change', (e) => {
      if (e.target && (e.target.name === 'id' || e.target.matches('select[name="id"]'))) {
        setVisibilityByVariantId(e.target.value);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    // init i hele dokumentet (trygt)
    initPreorderMessage(document);
  });

  // Theme editor / AJAX section reload
  document.addEventListener('shopify:section:load', (e) => {
    initPreorderMessage(e.target);
  });
})();
